export function returnWithoutTicketSettlement(client, returnAmount = 0) {
  const name = (client?.entreprise || [client?.nom, client?.prenom].filter(Boolean).join(' ')).trim().toUpperCase();
  const unpaid = !client || name === 'PASSAGER' ? 0 : Math.max(0, Number(client.totalDebit || 0) - Number(client.totalCredit || 0));
  return returnSettlement({ montantTotalTTC: unpaid, montantPaye: 0 }, [], returnAmount);
}

export function returnSettlement(ticket, returns = [], returnAmount = 0) {
  const cents = value => Math.round((Number(value) || 0) * 100);
  const previousCredit = returns.filter(r => ['VALIDE', 'COMPTABILISE'].includes(r.statut))
    .reduce((sum, r) => sum + Math.max(0, cents(r.montantTTC) - cents(r.montantPayeCash) - cents(r.montantPayeCarte)), 0);
  const unpaid = Math.max(0, cents(ticket.montantTotalTTC) - cents(ticket.montantPaye) - previousCredit);
  const amount = Math.max(0, cents(returnAmount));
  return { debtReduction: Math.min(amount, unpaid) / 100, refund: Math.max(0, amount - unpaid) / 100 };
}

export function remainingTicketLines(ticket, returns = []) {
  const used = new Map();
  const key = line => String(line.articleId) + ':' + Number(line.prixUnitaireTTC || 0);
  returns.filter(r => ['VALIDE', 'COMPTABILISE'].includes(r.statut)).forEach(r => (r.lignes || []).forEach(line => {
    used.set(key(line), (used.get(key(line)) || 0) + Number(line.quantiteRetournee || 0));
  }));
  return (ticket.lignes || []).map(line => {
    const quantity = Number(line.quantiteLivree ?? line.quantite ?? 0);
    const taken = Math.min(quantity, used.get(key(line)) || 0);
    used.set(key(line), (used.get(key(line)) || 0) - taken);
    const remaining = Math.max(0, quantity - taken);
    return { ...line, articleLibelle: line.articleNom || line.articleLibelle,
      quantiteLivree: remaining, quantiteOriginale: remaining, quantiteRetournee: remaining };
  }).filter(line => line.quantiteRetournee > 0);
}
